import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';

import * as contractService from '../services/contracts';

export const FETCH_ALLOWED_CONTRACTS_COUNT = createAsyncAction('FETCH_ALLOWED_CONTRACTS_COUNT');

export const fetchAllowedContractsCount = () => dispatch => {
  dispatch({ type: FETCH_ALLOWED_CONTRACTS_COUNT.pending });
  const apiCallParams = {
    query: contractService.ALLOWED_CONTRACTS_COUNT,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { contractsWhereActionIsAllowed: { totalCount } } }) =>
      dispatch({ type: FETCH_ALLOWED_CONTRACTS_COUNT.success, payload: { totalCount } }))
    .catch((err) => dispatch(errorAction(FETCH_ALLOWED_CONTRACTS_COUNT.failure, err)));
};
